export default "__VITE_ASSET__xowviU4m__"